// @ai-generated 2026-08-18T00:00:00+00:00 by malte.ulfers@tngtech.com using Claude Opus 5
import { COMPARE_GRANULARITY_LABEL, COMPARE_OPERATOR_LABEL } from '../fieldMetadata';
import { SynqoCompareGranularity, type SynqoCompareCondition } from '@Model';
import { OperandRenderer } from './OperandRenderer';

interface CompareRendererProps {
    node: SynqoCompareCondition;
}

export function CompareRenderer({ node }: CompareRendererProps) {
    const opLabel = COMPARE_OPERATOR_LABEL[node.operator];
    // Absent on every non-temporal compare, so the badge only appears where it changes the meaning.
    const granularityLabel = COMPARE_GRANULARITY_LABEL[node.granularity ?? SynqoCompareGranularity.Exact];

    return (
        <div className="rounded border border-(--mantine-color-outline-5) bg-(--mantine-color-secondary-0) p-3 shadow-sm">
            <div className="flex flex-row flex-wrap items-center gap-2 text-sm">
                <OperandRenderer operand={node.left} />
                <span className="text-(--mantine-color-text-5)">{opLabel}</span>
                <OperandRenderer operand={node.right} />
                {granularityLabel && (
                    <span
                        className="rounded bg-(--mantine-color-info-1) px-1.5 py-0.5 text-xs text-(--mantine-color-info-8)"
                        title="Vergleich ohne Uhrzeit — nur das Kalenderdatum zählt"
                    >
                        {granularityLabel}
                    </span>
                )}
            </div>
            {node.message && <div className="mt-1 text-xs text-(--mantine-color-text-4)">{node.message}</div>}
        </div>
    );
}
